export default __webpack_public_path__ + "static/media/folder-icon-black.20872e24.svg";